export default __webpack_public_path__ + "static/media/logo-text-black-rec-x.4db3ed1e.svg";